import { useState, useContext, useEffect, useRef } from 'react'
import { ProfileLayout } from '../layout'
import css from "./orders.module.scss"
import { Pagination } from '../../../componentsV1/pagination'
import { Input } from '../../../componentsV1/Input'
import { getCustomerOrdersApi, getCartApi } from '../../../api'
import { AuthContext } from '../../../context/auth'
import moment from 'moment'
import { getKeyByValue, countryCode } from '../../../utils/country'
import ReactPrint from "react-to-print";
import Invoice from '../../../components/Invoice'

export const Orders = () => {
  const invoiceRef = useRef(null)
  const onBeforeGetContentResolve = useRef();
  const { setIsLoading } = useContext(AuthContext);
  const [ordersTab, setOrdersTab] = useState("pending");
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [current, setCurrent] = useState(2);
  const [currentPage, setCurrentPage] = useState(0);
  const [orders, setOrders] = useState({});
  const [search, setSearch] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const [date, setDate] = useState(30);
  const [freeQuantity, setFreeQuantity] = useState(0)
  const [quantity, setQuantity] = useState(1)


  useEffect(() => {
    if (selectedOrder && selectedOrder?.items?.length > 0) {
      setQuantity(selectedOrder?.items?.reduce((acc, curr) => acc + curr?.quantity, 0))
      setFreeQuantity(selectedOrder?.items?.reduce((acc, curr) => acc + curr?.adjustments[0]?.metadata?.freeQty, 0))
    }
    else {
      setFreeQuantity(0)
      setQuantity(1)
    }
  }, [selectedOrder])

  useEffect(() => {
    if (selectedOrder) {
      onBeforeGetContentResolve.current && onBeforeGetContentResolve.current();
    }
  }, [selectedOrder]);


  useEffect(() => {
    setCurrentPage(0)
  }, [ordersTab])


  useEffect(() => {
    setIsLoading(true)
    getCustomerOrdersApi(ordersTab, search, moment().subtract(date, 'days').format('YYYY-MM-DD'), 10, currentPage * 10).then((res) => {
      if (res.data) {
        const tempOrders = res.data.orders?.map((order, index) => {
          return {
            ...order,
            orderStatus: order.status === 'pending' && order.payment_status !== 'captured' ? 1 : order.status === 'pending' && order.payment_status === 'captured' && order.fulfillment_status !== 'shipped' ? 2 : order.status === 'pending' && order.payment_status === 'captured' && order.fulfillment_status === 'shipped' ? 3 : order.status === 'completed' && 4
          }
        })
        setOrders({ ...res.data, orders: tempOrders })
        setIsLoading(false)
      } else {
        setOrders({})
        setIsLoading(false)
      }
    })
  }, [ordersTab, search, currentPage, date]);


  useEffect(() => {
    setSelectedIndex(null)
    setSelectedOrder(null)
    setSelectedItem(null)
  }, [ordersTab, currentPage])


  const getCartDataById = () => {
    setIsLoading(true)
    getCartApi(selectedOrder?.cart_id).then((res) => {
      if (res && res.data && res.data?.cart) {
        setSelectedItem(res?.data?.cart)
        setIsLoading(false)
      } else {
        setSelectedItem(null)
        setIsLoading(false)
      }
    })
  }

  useEffect(() => {
    if (selectedOrder?.cart_id) {
      getCartDataById()
    }
  }, [selectedOrder]);

  return (
    <ProfileLayout>
      <div className={css.wrapper}>
        <div className={css.orderDetailsContainer}>
          <div className={css.orderHeader}>
            <div className={css.tabContainer}>
              <button className={ordersTab === "pending" && css.tabActive} onClick={() => setOrdersTab("pending")}>Current Orders</button>
              <button className={ordersTab === "completed" && css.tabActive} onClick={() => setOrdersTab("completed")}>Completed Orders</button>
            </div>
            <div className={css.headerSearchContainer}>
              <Input type="text" search style={{ height: '40px', paddingLeft: '30px', width: '100%' }} placeholder={'Search'} value={search} onChange={(e) => setSearch(e.target.value)} />
              <select
                data-placeholder='Topic'
                value={date}
                placeholder='Select From Days'
                onChange={(e) => {
                  setDate(e.target.value)
                }}
              >
                <option value={30}>Last 30 Days</option>
                <option value={60}>Last 60 Days</option>
                <option value={90}>Last 90 Days</option>
              </select>
            </div>
          </div>
          <div className={css.tableContainer}>
            {orders && orders.orders?.length ?
              <>
                <table className={css.mainTable}>
                  <thead>
                    <tr>
                      <th>Date & Time </th>
                      <th>Invoice Number</th>
                      <th>Order Number</th>
                      <th>Total</th>
                      <th style={{ textAlign: 'right' }}>Status</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders?.orders?.map((business, index) => {
                      return (
                        <>
                          <tr
                            key={business?.id}
                          >
                            <td>
                              {business?.created_at ? moment(business?.created_at).format('MMMM DD, YYYY, h:mm A') : "-"}
                            </td>
                            <td>
                              {business?.payments ? business?.payments[0]?.id.slice(business?.payments[0]?.id.length - 5, business?.payments[0]?.id.length) : "-"}
                            </td>
                            <td>
                              {business?.display_id ? business?.display_id : "-"}
                            </td>
                            <td>
                              {business?.payments ? `$${(business?.payments[0]?.amount / 100)?.toFixed(2)}` : "-"}
                            </td>
                            <td className={css.status}>
                              <button className={business.orderStatus === 2 ? css.inProgress : business.orderStatus === 3 ? css.shipped : business.orderStatus === 4 && css.completed}>{business?.orderStatus === 1 ? <i class="fas fa-dot-circle f900"></i> : business.orderStatus === 2 ? <i class="far fa-spinner"></i> : business.orderStatus === 3 ? <i class="far fa-spinner"></i> : <i className='fas fa-check'></i>} {business.orderStatus === 1 ? 'Received' : business.orderStatus === 2 ? 'In Progress' : business.orderStatus === 3 ? 'Shipped' : 'Delivered'}</button>
                            </td>
                            <td style={{ cursor: "pointer" }} onClick={() => {
                              if (index === selectedIndex) {
                                setSelectedIndex(null)
                                setSelectedOrder(null)
                                setSelectedItem(null)
                              } else {
                                setSelectedIndex(index)
                                setSelectedOrder(business)
                              }
                            }}>
                              <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <button style={{ fontSize: '16px' }}>{selectedIndex === index ? <i className="far fa-eye-slash"></i> : <i className="far fa-eye"></i>}</button>
                              </span>
                            </td>
                          </tr>
                          {index === selectedIndex && <tr className={css.activeRow}>
                            <td colSpan={7}>
                              <div className={css.orderDetails}>
                                <span className={css.horizontalLine}></span>
                                <div className={css.steps} style={{ marginBottom: '50px' }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "start",
                                      alignItems: "center",
                                      marginBottom: "19px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        position: 'relative',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#0099FF",
                                        color: "#ffffff",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        border: "1px solid transparent",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: selectedOrder.orderStatus === 1 ? "#fff" : '#9A9A9A33',
                                          width: "8px",
                                          height: "8px",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <div className="timeline-status" style={{ position: 'absolute', bottom: '-45px', width: 'max-content', left: 0 }}>
                                        <h5 style={{ fontSize: '14px' }}>Received</h5>
                                        <h6 style={{ fontSize: '12px', fontWeight: 400 }}>{moment(selectedOrder?.created_at).format('MMMM DD, YYYY, h:mm A')}</h6>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        height: "1px",
                                        width: "33%",
                                        margin: ' 0 5px',
                                        backgroundColor: selectedOrder.orderStatus > 1 ? "#0099FF" : "#9A9A9A33",
                                      }}
                                      className="progress-connector-line"
                                    ></div>
                                    <div
                                      style={{
                                        position: 'relative',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: selectedOrder.orderStatus >= 2 ? "#0099FF" : "#9A9A9A33",
                                        color: "#ffffff",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        border: "1px solid transparent",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: selectedOrder.orderStatus >= 3 ? "transparent" : selectedOrder.orderStatus == 2 ? "#fff" : "transparent",
                                          width: "8px",
                                          height: "8px",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <div className="timeline-status" style={{ position: 'absolute', bottom: '-45px', width: 'max-content', textAlign: 'center' }}>
                                        <h5 style={{ fontSize: '14px' }}>In Progress</h5>
                                        <h6 style={{ fontSize: '12px', fontWeight: 400 }}>{selectedOrder?.payments[0]?.captured_at ? moment(selectedOrder?.payments[0]?.captured_at).format('MMMM DD, YYYY, h:mm A') : "-- --"}</h6>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        height: "1px",
                                        width: "33%",
                                        margin: ' 0 5px',
                                        backgroundColor: selectedOrder.orderStatus >= 3 ? "#0099FF" : "#9A9A9A33",
                                      }}
                                      className="progress-connector-line"
                                    ></div>
                                    <div
                                      style={{
                                        position: 'relative',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: selectedOrder.orderStatus >= 3 ? "#0099FF" : "#9A9A9A33",
                                        color: "#ffffff",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        border: "1px solid transparent",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: selectedOrder.orderStatus >= 4 ? "transparent" : selectedOrder.orderStatus == 3 ? "#fff" : 'transparent',
                                          width: "8px",
                                          height: "8px",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <div className="timeline-status" style={{ position: 'absolute', bottom: '-45px', width: 'max-content', textAlign: 'center' }}>
                                        <h5 style={{ fontSize: '14px' }}>Shipped</h5>
                                        <h6 style={{ fontSize: '12px', fontWeight: 400 }}>{selectedOrder?.fulfillments && selectedOrder?.fulfillments[0]?.shipped_at ? moment(selectedOrder?.fulfillments[0]?.shipped_at).format('MMMM DD, YYYY, h:mm A') : "-- --"}</h6>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        height: "1px",
                                        width: "33%",
                                        margin: ' 0 5px',
                                        backgroundColor: selectedOrder.orderStatus >= 4 ? "#0099FF" : "#9A9A9A33",
                                      }}
                                      className="progress-connector-line"
                                    ></div>
                                    <div
                                      style={{
                                        position: 'relative',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: selectedOrder.orderStatus >= 4 ? "#0099FF" : "#9A9A9A33",
                                        color: "#ffffff",
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "50%",
                                        border: "1px solid transparent",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: selectedOrder.orderStatus >= 4 ? "#fff" : "transparent",
                                          width: "8px",
                                          height: "8px",
                                          borderRadius: "50%",
                                        }}
                                      ></span>
                                      <div className="timeline-status" style={{ position: 'absolute', bottom: '-45px', width: 'max-content', right: 0, textAlign: 'right' }}>
                                        <h5 style={{ fontSize: '14px' }}>Delivered</h5>
                                        <h6 style={{ fontSize: '12px', fontWeight: 400 }}>{selectedOrder?.status === 'completed' ? moment(selectedOrder?.updated_at).format('MMMM DD, YYYY, h:mm A') : "-- --"}</h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className={css.horizontalLine}></div>
                                <div className={css.addressContainer}>
                                  <div className={css.leftContainer}>
                                    <div className={css.addressHeader}>
                                      <h4>Shipping Address</h4>
                                      {selectedOrder && selectedOrder?.fulfillments && selectedOrder?.fulfillments[0]?.metadata?.tracking_url && <a href={`${selectedOrder?.fulfillments[0]?.metadata?.tracking_url}`} target='_blank' className={css.trackBtn} rel="noreferrer"><i className='fal fa-truck' /> Track Order</a>}
                                    </div>
                                    <div className={css.address}>
                                      <div className={css.leftContainer}>
                                        <h4>{selectedOrder?.shipping_address?.company}</h4>
                                        <h4>{selectedOrder?.shipping_address?.address_1}, {selectedOrder?.shipping_address?.city}, {selectedOrder?.shipping_address?.province} {selectedOrder?.billing_address?.postal_code}, {getKeyByValue(countryCode, selectedOrder?.billing_address?.country_code?.toUpperCase())}</h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={css.rightContainer}>
                                    <h4>Billing Address</h4>
                                    <div className={css.address}>
                                      <div className={css.leftContainer}>
                                        <h4>{selectedOrder?.billing_address?.company}</h4>
                                        <h4>{selectedOrder?.billing_address?.address_1}, {selectedOrder?.billing_address?.city}, {selectedOrder?.billing_address?.province} {selectedOrder?.billing_address?.postal_code}, {getKeyByValue(countryCode, selectedOrder?.billing_address?.country_code?.toUpperCase())}</h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className={css.itemsContainer}>
                                  <div className={css.itemHeader}>
                                    <h4>Items</h4>
                                    <ReactPrint
                                      onAfterPrint={() => {
                                        setIsLoading(false)
                                      }}
                                      trigger={() => <span><i className="fas fa-eye"></i> Invoice</span>}
                                      content={() => invoiceRef.current}
                                    />

                                  </div>
                                  <div className={css.itemsWrapper}>
                                    {selectedItem?.items?.map((item, index) => {
                                      return <div className={css.item} key={item.id}>
                                        <h4>{item.variant?.title}</h4>
                                        <div className={css.itemDetails}>
                                          <div className={css.leftContainer}>
                                            <div className={css.details}>
                                              <h4>Cat ID#</h4>
                                              <h4>{item.variant?.product?.mid_code} {item.variant?.product?.material}</h4>
                                            </div>
                                            <div className={css.details}>
                                              <h4>Concentration</h4>
                                              <h4>{item.variant?.product?.concentration} mg/ml</h4>
                                            </div>
                                          </div>
                                          <div className={css.middleContainer}>
                                            <h4>Q-ty:</h4>
                                            <h4>{item.quantity}</h4>
                                          </div>
                                          <div className={css.rightContainer}>
                                            <h4>${((item.unit_price * item.quantity) / 100).toFixed(2)}</h4>
                                            {item.quantity > 1 && <h6>{(item.unit_price / 100).toFixed(2)} x {item.quantity}</h6>}
                                            {item?.adjustments[0]?.metadata?.freeQty && (
                                              <span className='free'>{item.adjustments[0].metadata.freeQty} item{item.adjustments[0].metadata.freeQty > 1 ? 's' : ''} free</span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    })}
                                  </div>
                                </div>
                                <div className={css.invoiceContainer}>
                                  <h4>Summary</h4>
                                  <div className={css.summary}>
                                    <div className={css.summaryHeader}>
                                      <h5>Payment Method</h5>
                                      <h5>{selectedOrder?.payments[0]?.provider_id === 'stripe' ? 'Credit Card' : 'Purchase Order'} {selectedOrder?.payments[0]?.provider_id === 'manual' && `(#${selectedItem?.context?.purchaseOrderNumber || '-'})`}</h5>
                                    </div>
                                    <span className={css.horizontalLine}></span>
                                    <div className={css.summaryDetails}>
                                      <div className={css.leftContainer}>
                                        <h5>Total Items</h5>
                                        <h5>Subtotal</h5>
                                        <h5>Tax</h5>
                                        <h5>Discount</h5>
                                        <h5>Shipping & Handling</h5>
                                        <h5>Grand Total</h5>
                                      </div>
                                      <div className={css.rightContainer} style={{ textAlign: 'right', alignItems: 'flex-end' }}>
                                        <h5>{selectedOrder?.items?.reduce((acc, item) => acc + item.quantity, 0)}</h5>
                                        <h5>${selectedOrder?.items?.reduce((acc, item) => acc + item.refundable / 100, 0).toFixed(2)}</h5>
                                        <h5>${selectedOrder?.tax_rate ? (selectedOrder?.tax_rate / 100)?.toFixed(2) : '0.00'}</h5>
                                        <h5>-${selectedOrder?.discount_total ? (selectedOrder?.discount_total / 100)?.toFixed(2) : 0}</h5>
                                        <h5>${selectedOrder?.shipping_methods?.reduce((acc, item) => acc + item.price / 100, 0).toFixed(2)}</h5>
                                        <h5 style={{ fontWeight: 700 }}>${(selectedOrder?.payments?.reduce((acc, item) => acc + item.amount / 100, 0)).toFixed(2)}</h5>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          }
                        </>
                      );
                    })}
                  </tbody>
                </table>
                {orders?.count / orders.limit > 1 && <Pagination total={orders?.count / orders.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
              </>
              : <div className={css.noItems}>
                <span>
                  <i class="fal fa-boxes"></i>
                </span>
                <p>No orders Yet.</p>
              </div>
            }
          </div>
        </div>
        <div className="print-map" style={{ display: 'none' }}>
          <Invoice reference={invoiceRef} selectedOrder={selectedOrder} selectedItem={selectedItem} />
        </div>
      </div>
    </ProfileLayout>
  )
}